<div class="rating-container">
  <h4 class="title">Matchpunkte</h4>
  <table class="container">
    <ng-container *ngFor="let scoreItem of eventRating.activity_scores">
      <tr *ngIf="scoreItem.score !== 0"
          class="score-item"
          [class.positive]="scoreItem.score > 0"
          [class.negative]="scoreItem.score < 0">
        <td width="5%" class="indicator"></td>
        <td width="20%" class="title">{{scoreItem.title}}:</td>
        <td width="10%" class="value">{{scoreItem.value}}</td>
        <td width="10%" class="points">{{scoreItem.score}}</td>
      </tr>
    </ng-container>
  </table>
</div>
